var map = {
	"./about-banner.png": 1943,
	"./candle.mp4": 7737,
	"./cards.mp4": 1265,
	"./cards/back.png": 1799,
	"./cards/back2.png": 9363,
	"./cards/cups 1.jpg": 6107,
	"./cards/cups 10.jpg": 2583,
	"./cards/cups 2.jpg": 7925,
	"./cards/cups 3.jpg": 4747,
	"./cards/cups 4.jpg": 3704,
	"./cards/cups 5.jpg": 1600,
	"./cards/cups 6.jpg": 1241,
	"./cards/cups 7.jpg": 4188,
	"./cards/cups 8.jpg": 4776,
	"./cards/cups 9.jpg": 2978,
	"./cards/cups king.jpg": 5546,
	"./cards/cups knight.jpg": 8358,
	"./cards/cups page.jpg": 7316,
	"./cards/cups queen.jpg": 2646,
	"./cards/major 0.jpg": 679,
	"./cards/major 1.jpg": 4273,
	"./cards/major 10.jpg": 7471,
	"./cards/major 11.jpg": 3145,
	"./cards/major 12.jpg": 9465,
	"./cards/major 13.jpg": 2387,
	"./cards/major 14.jpg": 8499,
	"./cards/major 15.jpg": 3748,
	"./cards/major 16.jpg": 5724,
	"./cards/major 17.jpg": 4978,
	"./cards/major 18.jpg": 7407,
	"./cards/major 19.jpg": 6097,
	"./cards/major 2.jpg": 1220,
	"./cards/major 20.jpg": 6420,
	"./cards/major 21.jpg": 6641,
	"./cards/major 3.jpg": 2448,
	"./cards/major 4.jpg": 8565,
	"./cards/major 5.jpg": 394,
	"./cards/major 6.jpg": 6252,
	"./cards/major 7.jpg": 3037,
	"./cards/major 8.jpg": 5840,
	"./cards/major 9.jpg": 8851,
	"./cards/pentacles 1.jpg": 4232,
	"./cards/pentacles 10.jpg": 8994,
	"./cards/pentacles 2.jpg": 7006,
	"./cards/pentacles 3.jpg": 5917,
	"./cards/pentacles 4.jpg": 9516,
	"./cards/pentacles 5.jpg": 7847,
	"./cards/pentacles 6.jpg": 5677,
	"./cards/pentacles 7.jpg": 8877,
	"./cards/pentacles 8.jpg": 2741,
	"./cards/pentacles 9.jpg": 9907,
	"./cards/pentacles king.jpg": 3559,
	"./cards/pentacles knight.jpg": 9703,
	"./cards/pentacles page.jpg": 690,
	"./cards/pentacles queen.jpg": 6769,
	"./cards/swords 1.jpg": 2941,
	"./cards/swords 10.jpg": 1457,
	"./cards/swords 2.jpg": 5032,
	"./cards/swords 3.jpg": 6687,
	"./cards/swords 4.jpg": 1777,
	"./cards/swords 5.jpg": 7702,
	"./cards/swords 6.png": 3256,
	"./cards/swords 7.jpg": 7539,
	"./cards/swords 8.jpg": 2075,
	"./cards/swords 9.jpg": 5954,
	"./cards/swords king.jpg": 7822,
	"./cards/swords knight.jpg": 5313,
	"./cards/swords page.jpg": 172,
	"./cards/swords queen.jpg": 2267,
	"./cards/wands 1.jpg": 3721,
	"./cards/wands 10.jpg": 7729,
	"./cards/wands 2.jpg": 5791,
	"./cards/wands 3.jpg": 1255,
	"./cards/wands 4.jpg": 7959,
	"./cards/wands 5.jpg": 4873,
	"./cards/wands 6.jpg": 35,
	"./cards/wands 7.jpg": 8691,
	"./cards/wands 8.jpg": 9770,
	"./cards/wands 9.jpg": 7404,
	"./cards/wands king.jpg": 6573,
	"./cards/wands knight.jpg": 7302,
	"./cards/wands page.jpg": 2585,
	"./cards/wands queen.jpg": 6722,
	"./darkwater.mp4": 8192,
	"./default1.jpg": 3441,
	"./ex.jpg": 3841,
	"./fire_tarot.png": 4922,
	"./fortune.mp4": 454,
	"./hero copy.mp4": 8844,
	"./hero.mov": 3569,
	"./hero.mp4": 3299,
	"./logo copy2.png": 2507,
	"./logo.png": 6061,
	"./logo2.png": 6657,
	"./main1 copy.png": 1204,
	"./main1.png": 9161,
	"./main2.png": 1932,
	"./main3.png": 7108,
	"./main4.png": 3643,
	"./particles.mp4": 8723,
	"./star.mp4": 5225,
	"./star2.mp4": 8734,
	"./tarot1.png": 9753,
	"./tarot2.png": 3425,
	"./tarot3.png": 8709,
	"./tarot4.png": 4456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8330;